import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";

const OurTeam = () => {
  const { t } = useTranslation();
  const scrollRef = useRef(null);
  const [selectedMember, setSelectedMember] = useState(null);
  const [isClosing, setIsClosing] = useState(false);

  const handleScroll = (direction) => {
    const scrollAmount = 300; 
    if (direction === "left") {
      scrollRef.current.scrollLeft -= scrollAmount;
    } else {
      scrollRef.current.scrollLeft += scrollAmount;
    }
  };

  const teamMembers = [
    {
      name: t("ourTeam.momir.name"),
      position: t("ourTeam.momir.position"),
      email: t("ourTeam.momir.mail"),
      image: "/images/momir.jpeg",
    },
    {
      name: t("ourTeam.finances.name"),
      position: t("ourTeam.finances.position"),
      email: t("ourTeam.finances.mail"),
      phone: t("ourTeam.finances.number"),
      image: "/images/finances.jpeg",
      backgroundPosition: "center 20%",
    },
    {
      name: t("ourTeam.tarifa.name"),
      position: t("ourTeam.tarifa.position"),
      email: t("ourTeam.tarifa.mail"),
      phone: t("ourTeam.tarifa.number"),
      image: "/images/tarifa.jpeg",
    },
    {
      name: t("ourTeam.transport.name"),
      position: t("ourTeam.transport.position"),
      email: t("ourTeam.transport.mail"),
      phone: t("ourTeam.transport.number"),
      image: "/images/transport.jpeg",
    },
    {
      name: t("ourTeam.carinskiSkladRakovoditel.name"),
      position: t("ourTeam.carinskiSkladRakovoditel.position"),
      email: t("ourTeam.carinskiSkladRakovoditel.mail"),
      phone: t("ourTeam.carinskiSkladRakovoditel.number"),
      image: "/images/javenCarinsliSklad.jpeg",
    },
    {
      name: t("ourTeam.pravnaSluzba.name"),
      position: t("ourTeam.pravnaSluzba.position"),
      email: t("ourTeam.pravnaSluzba.mail"),
      image: "/images/pravnaSluzba.jpeg",
    },
    {
      name: t("ourTeam.carinskaIspostavaSkopje.name"),
      position: t("ourTeam.carinskaIspostavaSkopje.position"),
      email: t("ourTeam.carinskaIspostavaSkopje.mail"),
      phone: t("ourTeam.carinskaIspostavaSkopje.number"),
      image: "/images/carinskaIspostavaSkopje.jpeg",
    },
    {
      name: t("ourTeam.deklarant3.name"),
      position: t("ourTeam.deklarant3.position"),
      email: t("ourTeam.deklarant3.mail"),
      image: "/images/deklarant3.jpeg",
    },
    {
      name: t("ourTeam.carinskaIspostavaTabanovce.name"),
      position: t("ourTeam.carinskaIspostavaTabanovce.position"),
      email: t("ourTeam.carinskaIspostavaTabanovce.mail"),
      phone: t("ourTeam.carinskaIspostavaTabanovce.number"),
      image: "/images/carinskaIspostavaTabanovce.jpeg",
    },
    {
      name: t("ourTeam.deklarant1.name"),
      position: t("ourTeam.deklarant1.position"),
      email: t("ourTeam.deklarant1.mail"),
      phone: t("ourTeam.deklarant1.number"),
      image: "/images/deklarant1.jpeg",
    },
    {
      name: t("ourTeam.deklarant4.name"),
      position: t("ourTeam.deklarant4.position"),
      email: t("ourTeam.deklarant4.mail"),
      phone: t("ourTeam.deklarant4.number"),
      image: "/images/deklarant4.jpeg",
    },
    {
      name: t("ourTeam.deklarant2.name"),
      position: t("ourTeam.deklarant2.position"),
      email: t("ourTeam.deklarant2.mail"),
      phone: t("ourTeam.deklarant2.number"),
      image: "/images/deklarant2.jpeg",
    },
    {
      name: t("ourTeam.carinskaIspostavaAerodrom.name"),
      position: t("ourTeam.carinskaIspostavaAerodrom.position"),
      email: t("ourTeam.carinskaIspostavaAerodrom.mail"),
      phone: t("ourTeam.carinskaIspostavaAerodrom.number"),
      image: "/images/worker.jpg",
    },
  ];

  const closePopup = () => {
    setIsClosing(true);
    setTimeout(() => {
      setSelectedMember(null);
      setIsClosing(false);
    }, 500);
  }; 

  return (
    <section id="team" className="px-5 max-w-[1290px] w-full mx-auto mt-32">
      <div className="mx-auto">
        <p className="font-bold text-[16px] leading-[20.8px] text-[#4F4F4F]">
          {t("ourTeam.ourTeam")}
        </p>
        <div className="flex flex-col lg:w-[30%]">
          <h2 className="text-[27.65px] leading-[33.18px] font-extrabold text-[#111111] mb-4 mt-10">
            {t("ourTeam.title")}
          </h2>
        </div>
        <p className="text-[#3D3D3D] mb-6 text-[16px] leading-[20.8px] font-normal mt-2">
          {t("ourTeam.description")}
        </p>
      </div>

      <div className="relative mt-20">
        <div
          ref={scrollRef}
          className="flex overflow-x-scroll scroll-smooth space-x-6 lg:-space-x-6 pb-4"
        >
          {teamMembers.map((member, index) => (
            <div
              key={index}
              className="min-w-[264px] flex-shrink-0 cursor-pointer"
              onClick={() => setSelectedMember(member)}
            >
              <div
              className="h-[224px] lg:w-[224px] w-full bg-[#E0E0E0] mb-4"
                style={{
                  backgroundImage: `url(${member.image})`,
                  backgroundSize: "cover",
                backgroundPosition: member.backgroundPosition || "center",
                }}
              ></div>
              <h3 className="text-[#3D3D3D] text-[16px] font-bold mb-2 leading-[20.8px] whitespace-pre-line">
              {member.name}
              </h3>

              <p className="text-[#3D3D3D] text-[13.33px] leading-[17.33px] font-[400]">
                {member.position}
              </p>
            </div>
          ))}
        </div>

        <div className="flex justify-between mt-4">
          <button onClick={() => handleScroll("left")}>
            <img src="/images/ArrowLeft.jpg" alt="" className="w-[32px] h-[32px]" />
          </button>
          <button onClick={() => handleScroll("right")}>
            <img src="/images/ArrowRight.jpg" alt="" className="w-[32px] h-[32px]" />
          </button>
        </div>
      </div>

      {selectedMember && (
        <div className={`fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 ${isClosing ? 'animate-fade-out' : 'animate-fade-in'}`}>
          <div className={`bg-white rounded-lg p-10 max-w-[400px] w-[90%] relative ${isClosing ? 'animate-slide-out' : 'animate-slide-in'}`}>
            <button
              onClick={closePopup}
              className="absolute top-3 right-4 text-gray-500 hover:text-gray-700"
            >
              ✕
            </button>

            <div
              className="h-[200px] w-full bg-[#E0E0E0] mb-4"
              style={{
                backgroundImage: `url(${selectedMember.image})`,
                backgroundSize: "cover",
                backgroundPosition: selectedMember.backgroundPosition || "center",
              }}
            ></div>
            <h3 className="text-[#111111] text-[20px] font-bold mb-2">
              {selectedMember.name}
            </h3>
            <p className="text-[#3D3D3D] text-[16px] font-medium mb-4">
              {selectedMember.position}
            </p>
            <p className="text-[#3D3D3D] text-[14px] font-normal">
              <strong>{t('contactus.email')}:</strong> {selectedMember.email}
            </p>
            {selectedMember.phone && (
              <p className="text-[#3D3D3D] text-[14px] font-normal">
                <strong>{t("contactus.phone")}:</strong> {selectedMember.phone}
              </p>
            )}
          </div>
        </div>
      )}
    </section>
  );
};

export default OurTeam;
